   import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2735,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
	
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dgv4gm3q_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9ep8zf8y_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ch0luhh3_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/osmfjvjc_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Lessons"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 41,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 36,
							}} >
							{"Explore all lessons."}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginBottom: 40,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 24,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"List of Lessons"}
							</span>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 3,
									marginBottom: 28,
									gap: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lm3c2t6t_expires_30_days.png"} 
									style={{
										width: 9,
										height: 22,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Lesson List"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											paddingTop: 21,
											paddingBottom: 4,
											gap: 7,
											backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/aq2xs7mg_expires_30_days.png)',
											backgroundSize: "cover",
											backgroundPosition: "center",
										}}>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jhxx7bki_expires_30_days.png"} 
												style={{
													width: 19,
													height: 19,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												marginLeft: 25,
												gap: 2,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ah2iy0w7_expires_30_days.png"} 
												style={{
													width: 8,
													height: 8,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 8,
													fontWeight: "bold",
												}} >
												{"10:45"}
											</span>
										</div>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Understanding Market Research"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Video (10 min)"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7qcb1pap_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"Completed"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 113,
										paddingRight: 113,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Review Lesson"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w6vu8w8h_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 16,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yftffojc_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Business Planning Strategies"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m3ibokhz_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#EEBD10",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"In Progress"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 130,
										paddingRight: 130,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Continue"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2s3hvbbv_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									marginBottom: 24,
									gap: 16,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vshp7rke_expires_30_days.png"} 
										style={{
											width: 61,
											height: 61,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Financial Projections for Startups"}
										</span>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Lesson Type: Text Lesson"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												paddingRight: 3,
												gap: 4,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/10ofzsfo_expires_30_days.png"} 
												style={{
													width: 11,
													height: 11,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 11,
													fontWeight: "bold",
												}} >
												{"Not Started"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 127,
										paddingRight: 127,
										marginLeft: 16,
										marginRight: 16,
										gap: 6,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											paddingBottom: 1,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Start now"}
										</span>
									</div>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7wxoyj2e_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 11,
											height: 11,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<button 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#E6F7FD",
									borderRadius: 8,
									border: "none",
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 109,
									paddingRight: 109,
									gap: 9,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#00AEEF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Browse All Lessons"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jh6o53td_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</button>
						</div>
						<div 
							style={{
								width: 1,
								height: 1045,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Lesson Details"}
							</span>
							<div 
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 16,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 24,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										paddingRight: 3,
										marginRight: 255,
										gap: 2,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9dyyc7im_expires_30_days.png"} 
										style={{
											width: 9,
											height: 22,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
										}} >
										{"Lesson Details"}
									</span>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										paddingRight: 2,
										gap: 2,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/aiehvo9j_expires_30_days.png"} 
										style={{
											width: 9,
											height: 22,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
										}} >
										{"Lesson Title & Summary"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 12,
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 28,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ov8s0lgd_expires_30_days.png"} 
										style={{
											width: 362,
											height: 121,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
										}} >
										{"Lesson Type"}
									</span>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 18,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Understanding Market Research"}
									</span>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginBottom: 19,
											width: 294,
										}} >
										{"This lesson covers essential market research techniques to identify customer needs and analyze competition."}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FEF0E9",
											borderRadius: 8,
											paddingTop: 10,
											paddingBottom: 10,
											paddingLeft: 12,
											paddingRight: 12,
											gap: 8,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0ok4gm6p_expires_30_days.png"} 
											style={{
												width: 25,
												height: 25,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												gap: 4,
											}}>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 10,
												}} >
												{"Completion Time"}
											</span>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Approx. 15 min"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 17,
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 24,
									}}>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"Text Lesson"}
									</span>
									<div 
										style={{
											width: 362,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 8,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rvstlijx_expires_30_days.png"} 
										style={{
											width: 25,
											height: 25,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Lesson Progress"}
										</span>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Completed 25%"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginBottom: 20,
											gap: 12,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
											}} >
											{"Lesson"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Understanding Market Research"}
										</span>
									</div>
									<div 
										style={{
											width: 362,
											height: 1,
											background: "#E6E6E6",
											marginBottom: 19,
										}}>
									</div>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 12,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
											}} >
											{"Introduction"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
												width: 309,
											}} >
											{"Market research is the process of gathering, analyzing, and interpreting data about a target market, product, or service."}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginTop: 2,
										marginBottom: 2,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											marginBottom: 20,
											gap: 2,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2q9cevk3_expires_30_days.png"} 
											style={{
												width: 9,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
											}} >
											{"Key Takeaways"}
										</span>
									</div>
									<span 
										style={{
											color: "#1074BC",
											fontSize: 14,
											fontWeight: "bold",
											width: 242,
										}} >
										{"Market research helps identify customer pain points and demand gaps."}
									</span>
									<span 
										style={{
											color: "#1074BC",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 28,
											width: 256,
										}} >
										{"Competitive analysis is essential for positioning your brand effectively."}
									</span>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											gap: 2,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4qqzgjrp_expires_30_days.png"} 
											style={{
												width: 9,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
											}} >
											{"Downloadable Resources"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 3,
									gap: 32,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 12,
											marginBottom: 12,
										}} >
										{"Types of Market Research"}
									</span>
									<span 
										style={{
											color: "#1074BC",
											fontSize: 14,
											marginBottom: 12,
											width: 342,
										}} >
										{"Primary Research: Conducting surveys, interviews, focus groups"}
									</span>
									<span 
										style={{
											color: "#1074BC",
											fontSize: 14,
											marginBottom: 16,
											width: 358,
										}} >
										{"Secondary Research: Using existing reports, industry trends, government publications"}
									</span>
									<div 
										style={{
											width: 362,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 20,
									}}>
									<button 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#E6F7FD",
											borderRadius: 8,
											border: "none",
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 52,
											paddingRight: 52,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dva8rbbr_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												marginRight: 6,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
												marginRight: 8,
											}} >
											{"Download PDF Guide"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3sjdho1a_expires_30_days.png"} 
											style={{
												width: 7,
												height: 11,
												objectFit: "fill",
											}}
										/>
									</button>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											gap: 2,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qw98yg3b_expires_30_days.png"} 
											style={{
												width: 9,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 18,
												fontWeight: "bold",
											}} >
											{"Ask Giia (AI Mentor)"}
										</span>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FEF0E9",
											borderRadius: 8,
											paddingTop: 12,
											paddingBottom: 12,
											paddingLeft: 28,
											paddingRight: 28,
											gap: 6,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												paddingRight: 2,
												gap: 8,
											}}>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ubwg7xqy_expires_30_days.png"} 
												style={{
													width: 25,
													height: 25,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#F36421",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"Have a question? Ask Giia!"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xtz94hr5_expires_30_days.png"} 
											style={{
												width: 7,
												height: 11,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginBottom: 20,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Key Steps in Market Research:"}
								</span>
								<span 
									style={{
										color: "#010101",
										fontSize: 14,
										fontWeight: "bold",
										width: 307,
									}} >
									{"Define the Research Objective\nIdentify Target Audience\nCollect Data (Surveys, Questionnaires, etc.)\nAnalyze Data and Generate Insights"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									gap: 12,
								}}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"Example:"}
								</span>
								<span 
									style={{
										color: "#010101",
										fontSize: 14,
										fontWeight: "bold",
										width: 358,
									}} >
									{"If you're launching a new fitness app, market research can help you understand what features users want most."}
								</span>
							</div>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 40,
							paddingRight: 28,
							marginLeft: 234,
							boxShadow: "0px -2px 4px #00000000",
						}}>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
								marginRight: 502,
							}} >
							{"© 2025 Global Impact Innovators. All Rights Reserved."}
						</span>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
								marginRight: 27,
							}} >
							{"Privacy"}
						</span>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
								marginRight: 26,
							}} >
							{"Terms of Service"}
						</span>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
							}} >
							{"Help & FAQ"}
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}